import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, IconButton, Typography, Button, Card, CardContent, TextField, List, Box, ListItem, ListItemText, DialogActions, Divider, Container, FormLabel, Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";
import { ArrowBack, Remove, Add, Delete, Discount, ArrowForward } from "@mui/icons-material";
import GroupedCartPopup from "./modals/groupedCartItems";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const CartOlympiad = ({ payload, series, initialCartItems, proceed, setCart, seriesD, editMode, newDataProp, isSpecimen, tntAmount, attachments1 }) => {
    const [cartItems, setCartItems] = useState([]);
    const [discountPopup, setDiscountPopup] = useState(false);
    const [discounts, setDiscounts] = useState({})
    const [open, setOpen] = useState(false);
    const [files, setFiles] = useState([]);
    const [attachments, setAttachment] = useState([]);
    const [tentativeAmount, setTentativeAmount] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedPdf, setSelectedPdf] = useState(null);
    console.log(payload, "cart ka payloadpayloadpayloadpayload")
    const parsedAttachments = React.useMemo(() => {
        if (!attachments1) return [];
        let value = attachments1;
        try {
            if (typeof value === "string") {
                value = JSON.parse(value);
            }
            if (typeof value === "string") {
                value = JSON.parse(value);
            }
            if (Array.isArray(value)) return value;
            if (typeof value === "object") return [value];
        } catch (err) {
            console.error("Attachment parse failed:", attachments1, err);
        }
        return [];
    }, [attachments1]);

    const handleQuantityChange = (index, delta) => {
        setCartItems((prev) => {
            const updated = prev.map((item, i) =>
                i === index ? { ...item, qty: Math.max(1, item.qty + delta) } : item
            );
            const id = updated[index].itemId;
            const temp = initialCartItems.map((item) =>
                item.data.skuId === id
                    ? { ...item, quantity: Math.max(1, item.quantity + delta) }
                    : item
            );
            setCart(temp);
            return updated;
        });
    };

    const handleRemoveItem = (index) => {
        const id = cartItems[index].itemId;
        setCartItems((prev) => prev.filter((_, i) => i !== index));
        const temp = initialCartItems.filter(
            (item) => item.data.skuId !== id
        );
        setCart(temp);
    };

    const getTotalPrice = () => {
        return cartItems.reduce((total, item) => total + (item.price * item.qty) * (1 - item.discount / 100), 0);
    };

    function setData() {
        const newCartItems = [];
        initialCartItems.forEach((order) => {
            const quantity = parseInt(order.quantity, 10) || 1;
            const group = order.group;
            const item = order.data || {};

            newCartItems.push({
                name: item?.nameSku,
                sku_code: item?.sku_code,
                productGroup: group,
                bookType: order.bookType || "",
                class: order.class || "",
                price: item.unitPrice != null ? parseFloat(item.unitPrice) : parseFloat(item.landing_cost) || 0.0,
                qty: quantity,
                series: item.seriesCategory || "",
                itemId: item.skuId || item.id,
                total: item.unitPrice != null ? (parseFloat(item.unitPrice) * quantity || 0.0) : 0.0,
                discount: item.discount ? item.discount : 0,
                itemType: order.orderType,
            });
        });
        setCartItems(newCartItems);
    }

    useEffect(() => { setData() }, [])

    useEffect(() => {
        if (seriesD) {
            let parsed = seriesD;
            if (typeof seriesD === 'string') {
                try {
                    parsed = JSON.parse(seriesD);
                } catch (e) {
                    parsed = {};
                }
            }
            setDiscounts(parsed || {});
        }
    }, [seriesD]);

    useEffect(() => {
        if (cartItems.length === 0) return;
        setCartItems((prev) =>
            prev.map((item) => ({ ...item, discount: discounts[item.series] ?? item.discount ?? 0 }))
        );
    }, [discounts]);

    useEffect(() => {
        setTentativeAmount(tntAmount || "")
    }, [editMode])

    function applyD(discountsObj) {
        let temp = [...cartItems];
        temp.forEach((ele) => {
            ele.discount = discountsObj[ele.series] ?? 0;
        });
        setDiscountPopup(false);
        setCartItems(temp);
        setDiscounts(discountsObj || {});
    }

    function payloadCreate() {
        if (!editMode && payload?.orderProcess == "upload" && (payload?.orderType?.toLowerCase() == "specimen" || payload?.orderType === "Sales" || payload?.orderType === "saleS") && attachments == "") {
            alert("Please upload attachment before proceeding.")
            return;
        }
        if (payload?.orderType?.toLowerCase() != "specimen" && payload?.applyDiscount == "yes") {
            let seriesList = [];
            if (payload?.orderProcess == "upload" && payload?.uploadSeries) {
                seriesList = Array.isArray(payload.uploadSeries) ? payload.uploadSeries : [payload.uploadSeries];
            } else {
                seriesList = [...new Set(cartItems.map(item => item.series).filter(Boolean))];
            }
            if (payload && payload?.orderType !== "Specimen" && payload?.orderProcess == "upload" && tentativeAmount == "" && tentativeAmount < 0) {
                alert("Please Enter Tentative Amount");
                return;
            }
            if (payload && payload?.orderType !== "Specimen" && payload?.orderProcess === "upload" && (!tentativeAmount || Number(tentativeAmount) <= 0)) {
                alert("Please enter Tentative Amount");
                return;
            }

            const allSeriesHaveDiscount = seriesList.length > 0 &&
                seriesList.every(series => (discounts[series] ?? 0) >= 0);

            if (!allSeriesHaveDiscount) {
                alert("Discount must be filled for all series");
                return;
            }
        }
        var body = { ...payload };
        body['totalAmount'] = body['orderType'].toLowerCase() == 'sales' ? getTotalPrice() : 0;
        body['seriesDiscount'] = discounts;
        body['attachments'] = attachments || attachments1 || [];
        body['tentativeAmount'] = tentativeAmount;
        body['orders'] = cartItems.map((item) => {
            return {
                'itemId': item.itemId,
                'name': item.name,
                'price': item.price,
                'qty': item.qty,
                'productGroup': item.productGroup,
                'orderType': item.itemType ?? "",
                'total': payload['orderType'].toLowerCase() == 'sales' ? item.price * item.qty * (1 - item.discount / 100) : 0,
                'class': item.class || "",
                'bookType': item.bookType || "",
            };
        });
        proceed(cartItems, body)
    }

    const getFilePreview = (file) => {
        if (file.type.startsWith('image/')) {
            return <img src={URL.createObjectURL(file)} alt={file.name} style={{ maxWidth: '100%', height: '100px' }} />;
        } else {
            return <InsertDriveFileIcon style={{ fontSize: 50, height: "100px", }} />;
        }
    };

    const handleFileChange = (event) => {
        setFiles([...event.target.files]);
        setOpen(true);
    };

    const handleUpload = async () => {
        const formData = new FormData();
        files.forEach((file, index) => {
            formData.append(`files`, file);
        });

        try {
            const response = await window.Platform.database.uploadMultipleImages(formData);
            if (response) {
                const result = await response
                let temp = [...attachments]
                result.data.files.forEach((ele) => {
                    temp.push(ele)
                });
                setAttachment(temp)

                setOpen(false);
            } else {
                alert('Failed to upload files.');
            }
        } catch (error) {
            console.error('Upload error:', error);
            alert('Error uploading files.');
        }
    };

    const handleImageClick = (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
        window.open(url, "_blank");
        setSelectedImage(file);
        setSelectedPdf(null);
    };

    const handlePdfClick = (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
        window.open(url, "_blank");
        setSelectedPdf(file);
        setSelectedImage(null);
    };

    const downloadFile = async (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = file.originalName || file.fileName || "download";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Download failed:", err);
        }
    };
    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };
    return (
        <Container>
            <div>

                <Card sx={{ p: 2, mb: 2 }}>
                    <Typography style={{ color: "#000", fontSize: "20px", fontWeight: 600 }} gutterBottom> Olympiad Summary </Typography>
                    <Typography><span style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>Registration Type: </span><span style={{ fontSize: "13px", fontWeight: "500", color: "black" }}> {payload?.olympiadDetails?.registrationTypeName}</span></Typography>
                    <Typography><span style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>Medium: </span><span style={{ fontSize: "13px", fontWeight: "500", color: "black" }}> {payload?.olympiadDetails?.mediumName}</span></Typography>
                    <Typography><span style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>Exam Date: </span><span style={{ fontSize: "13px", fontWeight: "500", color: "black" }}> {formatDate(payload?.olympiadDetails?.examDate)}</span></Typography>
                </Card>

                {payload?.olympiadDetails?.classSubjects?.map((cls, index) => {
                    let classTotal = 0;
                    return (
                        <Card
                            key={index}
                            sx={{
                                mb: 3,
                                borderRadius: 3,
                                boxShadow: 2,
                                overflow: "hidden"
                            }}
                        >
                            {/* CLASS HEADER */}
                            <Box sx={{ bgcolor: "#f5f7fa", p: 2 }}>
                                <Typography style={{ color: "#000", fontSize: "16px", fontWeight: 600 }}>
                                    {cls.className}
                                </Typography>
                            </Box>

                            {/* TABLE HEADER */}
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
                                    px: 2,
                                    py: 1,
                                    bgcolor: "#fafafa",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    borderBottom: "1px solid #b8b4b4",
                                }}
                            >
                                <span style={{ color: "#000", fontSize: "15px", fontWeight: 600, textAlign: "center" }}>Subject</span>
                                <span style={{ color: "#000", fontSize: "15px", fontWeight: 600, textAlign: "center" }}>Students</span>
                                <span style={{ color: "#000", fontSize: "15px", fontWeight: 600, textAlign: "center" }}>Study Kit</span>
                                <span style={{ color: "#000", fontSize: "15px", fontWeight: 600, textAlign: "center" }}>Amount</span>
                            </Box>

                            {/* SUBJECT ROWS */}
                            {cls.subjects.map((sub, i) => {
                                const price = 112.5;
                                const total = (sub.materialQty || 0) * price;
                                classTotal += total;

                                return (
                                    <Box
                                        key={i}
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
                                            px: 2,
                                            py: 1.5,
                                            borderTop: "1px solid #eee",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography style={{ color: "#000", fontSize: "12px", fontWeight: 600, textAlign: "center" }}>{sub.subjectName || "N/A"}</Typography>

                                        <Typography style={{ color: "#000", fontSize: "12px", fontWeight: 600, textAlign: "center" }}>{sub.studentCount || 0}</Typography>

                                        <Typography style={{ color: "#000", fontSize: "12px", fontWeight: 600, textAlign: "center" }}>{sub.materialQty || 0}</Typography>

                                        <Typography style={{ color: "#000", fontSize: "12px", fontWeight: 600, textAlign: "center" }}>
                                            ₹{total.toFixed(2)}
                                        </Typography>
                                    </Box>
                                );
                            })}

                            {/* CLASS TOTAL */}
                            <Box
                                sx={{
                                    textAlign: "right",
                                    p: 2,
                                    bgcolor: "#fafafa",
                                    borderTop: "1px solid #ddd"
                                }}
                            >
                                <Typography fontWeight="bold">
                                    Class Total: ₹{classTotal.toFixed(2)}
                                </Typography>
                            </Box>
                        </Card>
                    );
                    // return (
                    //     <Card key={index} sx={{ mb: 2, p: 2 }}>
                    //         <Typography variant="h6">{cls.className}</Typography>

                    //         {cls.subjects.map((sub, i) => {
                    //             const price = 112.5; // 🔥 you can map dynamically later
                    //             const total = (sub.studentCount || 0) * price;
                    //             classTotal += total;

                    //             return (
                    //                 <Box key={i} sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                    //                     <Typography>
                    //                         {sub.subjectName}
                    //                     </Typography>

                    //                     <Typography>
                    //                         Students: {sub.studentCount || 0}
                    //                     </Typography>

                    //                     <Typography>
                    //                         Study Kit: {sub.materialQty || 0}
                    //                     </Typography>

                    //                     <Typography>
                    //                         ₹{price} × {sub.studentCount || 0} = ₹{total}
                    //                     </Typography>
                    //                 </Box>
                    //             );
                    //         })}

                    //         <Divider sx={{ my: 1 }} />

                    //         <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    //             Class Total: ₹{classTotal.toFixed(2)}
                    //         </Typography>
                    //     </Card>
                    // );
                })}

                {/* 🔹 GRAND TOTAL */}
                <Card sx={{ p: 2, mt: 2 }}>
                    <Typography variant="h6" align="right">
                        Grand Total: ₹{
                            payload?.olympiadDetails?.classSubjects?.reduce((grand, cls) => {
                                return grand + cls.subjects.reduce((sum, sub) => {
                                    return sum + ((sub.studentCount || 0) * 112.5);
                                }, 0);
                            }, 0).toFixed(2)
                        }
                    </Typography>
                </Card>

                {/* 🔹 PROCEED BUTTON */}
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        endIcon={<ArrowForward />}
                        onClick={() => payloadCreate()}
                    >
                        Confirm & Proceed
                    </Button>
                </Box>

            </div>
        </Container>
    );
};

export default CartOlympiad;